export const GRAPHQL_VARIABLES = {};

export const QUERY = `
 query getStripeOnboardLink{
    whoami{
      stripeOnboardLink
    }
 }
 `;
